import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent {

  @Input()
  required  = false
  @Input()
  title = 'title'

  @Input()
  inputType : 'text' | 'radio' | 'check' = 'text'

  @Input()
  inputSuffixe = ''

}
